import { Button, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ButtonLoading } from "src/components/ButtonLoading";
import { ServerErrors } from "src/components/form-components/ServerErrors";
import type { APIError } from "src/types";

interface Props {
  onClose: () => void;
  onSave: () => void;
  disabled: boolean;
  errors?: APIError[] | Error;
  isLoading: boolean;
}

export function FleetConfigFooter(props: Props) {
  const { onClose, onSave, disabled, errors, isLoading } = props;
  const { t } = useTranslation();
  return (
    <Styles className="upload-footer">
      {errors && <ServerErrors data={errors} />}
      <div className="action-buttons">
        <Button variant="text" color="primary" onClick={onClose}>
          {t("label.close")}
        </Button>
        <ButtonLoading isLoading={isLoading} color="primary" variant="contained" disabled={disabled} onClick={onSave}>
          {t("label.save")}
        </ButtonLoading>
      </div>
    </Styles>
  );
}

const Styles = styled("div")`
  display: flex;
  gap: 16px;
  flex-direction: column;
  .action-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
  padding: 24px 0;
  padding-top: 20px;
  margin-top: auto;
`;
